import React from 'react';
import { getOfferStatusStyle, resolveDiscountStatus } from '../utils/offerStatus';
import './OfferStatusBadge.css';

/**
 * Status badge for host/admin dashboards.
 * @param {string} [status] - explicit status
 * @param {object} [discount] - property discount object (status inferred)
 */
const OfferStatusBadge = ({ status, discount, className = '' }) => {
  const resolved = status || resolveDiscountStatus(discount);
  const style = getOfferStatusStyle(resolved);

  return (
    <span
      className={`offer-status-badge offer-status-${resolved} ${className}`}
      style={{
        backgroundColor: style.bg,
        color: style.textColor,
        borderColor: `${style.color}33`,
      }}
    >
      {style.label}
    </span>
  );
};

export default OfferStatusBadge;
